import React, { ReactNode } from 'react';
import { CSSProperties } from 'styled-components';

type Props = {
  children: ReactNode;
  hasElementsAbove?: boolean;
  classNames?: string;
  style?: CSSProperties;
  bodyStyle?: CSSProperties;
  contentStyle?: CSSProperties;
};

const TableContainer: React.FC<Props> = ({
  children,
  hasElementsAbove = false,
  classNames = '',
  style = {},
  bodyStyle = {},
  contentStyle
}) => {
  return (
    <div
      className={`panel table table-responsive ${
        hasElementsAbove ? '' : 'mt-xs'
      } ${classNames}`}
      style={style as any}
    >
      <div className="panel-body" style={bodyStyle as any}>
        {contentStyle ? (
          <div style={contentStyle as any}>{children}</div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export { TableContainer };
